import { gql, useQuery } from "utils/urql";
import ArticleRelatedContentList from "./ArticleRelatedContentList";
import {
  ChannelRelatedContentQuery,
  ChannelRelatedContentQueryVariables,
} from "types/api";

const CHANNEL_RELATED_QUERY = gql`
  ${ArticleRelatedContentList.fragment}

  query ChannelRelatedContentQuery($slug: String!, $id: ID!) {
    channel(slug: $slug) {
      displayName
      river(first: 3, excludes: [$id]) {
        ...relatedContentRiver
      }
    }
  }
`;

const ArticleRelatedContentChannel = ({
  slug,
  id,
  count,
}: {
  slug: string;
  id: string;
  count: number;
}) => {
  const [{ data }] = useQuery<
    ChannelRelatedContentQuery,
    ChannelRelatedContentQueryVariables
  >({
    query: CHANNEL_RELATED_QUERY,
    variables: {
      slug,
      id,
    },
  });
  const content = data?.channel;
  if (!content?.river?.edges.length) return null;
  return (
    <ArticleRelatedContentList
      displayName={`Latest from ${content.displayName}`}
      articles={content.river}
      count={count}
    />
  );
};

export default ArticleRelatedContentChannel;
